/* -----------------UI--------------- */
import { isIOS } from "@memorang/helpers/platform";
import type { ButtonProps } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useSafeAreaInsets } from "react-native-safe-area-context";

import type { IconType } from "../../icon";
/* -----------------Child components--------------- */
import Box from "../Box";
import Button from "../Button";

interface Props extends ButtonProps {
	onPress: () => void;
	buttonText: string;
	children: React.ReactNode;
	maxWidth?: "xs" | "sm" | "md" | "lg";
	showButton?: boolean;
	paddingHorizontal?: number;
}

const StickyButtonContainer = ({
	onPress,
	buttonText,
	children,
	showButton = true,
	paddingHorizontal = 16,
	...buttonProps
}: Props) => {
	const insets = useSafeAreaInsets();
	return (
		<Box flex={1}>
			<Box style={{ flex: 1 }}>
				{children}
				{showButton && (
					<Box
						style={{
							paddingBottom: insets.bottom + (isIOS ? 0 : 16),
							paddingHorizontal,
							paddingTop: 24,
						}}
					>
						<Button
							mode="contained"
							onPress={onPress}
							{...buttonProps}
							icon={buttonProps.icon as IconType}
						>
							{buttonText}
						</Button>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default StickyButtonContainer;
